exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer {\n  margin: 10rem 5% 2rem 5%;\n  border-top: 1px solid #777;\n  padding: 1rem 5% 0 5%;\n  text-align: right;\n  font-size: 11px; }\n", ""]);

